import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-backTop",
  "use": "icon-backTop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-backTop\"><path d=\"M463.218 198.286a56.889 56.889 0 0197.564 0L902.144 767.26a56.804 56.804 0 01-48.782 86.073H170.667a56.804 56.804 0 01-48.783-86.073L463.19 198.286z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol